/**
 * Power Platform Code App adapter — production path for `pac code push`.
 *
 * Delegates to the Power SDK's Dataverse client which handles auth via the
 * host app context (no MSAL config needed). Same OOB tables, same shapes.
 *
 * Stub for now — implement once the first push succeeds and we know the
 * exact SDK surface available to the app.
 */
export class PowerSdkAdapter {
    constructor() {
        Object.defineProperty(this, "listAccounts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listAccounts")
        });
        Object.defineProperty(this, "listWorkOrders", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listWorkOrders")
        });
        Object.defineProperty(this, "listProjects", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listProjects")
        });
        Object.defineProperty(this, "listProjectTasks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listProjectTasks")
        });
        Object.defineProperty(this, "listBookings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listBookings")
        });
        Object.defineProperty(this, "listTransactionCategories", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listTransactionCategories")
        });
        Object.defineProperty(this, "listResources", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listResources")
        });
        Object.defineProperty(this, "listDirectReports", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listDirectReports")
        });
        Object.defineProperty(this, "listStaffTimeEntries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listStaffTimeEntries")
        });
        Object.defineProperty(this, "createStaffTimeEntry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("createStaffTimeEntry")
        });
        Object.defineProperty(this, "updateStaffTimeEntry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("updateStaffTimeEntry")
        });
        Object.defineProperty(this, "submitStaffTimeEntry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("submitStaffTimeEntry")
        });
        Object.defineProperty(this, "listResourceCategories", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listResourceCategories")
        });
        Object.defineProperty(this, "listTimeEntries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listTimeEntries")
        });
        Object.defineProperty(this, "createTimeEntry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("createTimeEntry")
        });
        Object.defineProperty(this, "updateTimeEntry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("updateTimeEntry")
        });
        Object.defineProperty(this, "deleteTimeEntry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("deleteTimeEntry")
        });
        Object.defineProperty(this, "markWhmcsPosted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("markWhmcsPosted")
        });
        Object.defineProperty(this, "approveEntries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("approveEntries")
        });
        Object.defineProperty(this, "returnEntries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("returnEntries")
        });
        Object.defineProperty(this, "selfApproveEntries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("selfApproveEntries")
        });
        Object.defineProperty(this, "selfReturnEntries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("selfReturnEntries")
        });
        Object.defineProperty(this, "submitEntries", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("submitEntries")
        });
        Object.defineProperty(this, "listAnnotations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listAnnotations")
        });
        Object.defineProperty(this, "listPendingForManager", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listPendingForManager")
        });
        Object.defineProperty(this, "listPendingForSelf", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listPendingForSelf")
        });
        Object.defineProperty(this, "listPendingDelegated", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: notImplemented("listPendingDelegated")
        });
    }
}
function notImplemented(name) {
    return ((..._args) => {
        throw new Error(`[PowerSdkAdapter] ${name} not yet wired. Set VITE_BACKEND=mock until first \`pac code push\` succeeds.`);
    });
}
